module.exports = __webpack_public_path__ + "img/qrcode.cedf3c7f.jpg";